{
	"dateInfoNotAvailable": "View not available",
	"monthDays": "Total {{monthDays}} days"
}
